import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MainRoutingModule } from "./main-routing.module";
import { MainComponent } from "./main.component";
import { FullComponent } from "../layouts/full/full.component";
import { AppSidebarComponent } from "../layouts/full/sidebar/sidebar.component";
import { SharedModule } from "../shared/shared.module";
import { GoogleChartsModule } from "angular-google-charts";
import { MainHeaderComponent } from "../layouts/full/main-header/main-header.component";
import { HomeComponent } from "./home/home.component";
import { MainService } from "./main.service";
import { QuestionListComponent } from "./home/question-list/question-list.component";
import { ProfileComponent } from "./home/profile/profile.component";
import { ChoirDetailComponent } from "./home/choir-detail/choir-detail.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { SavedChoirsComponent } from "./home/saved-choirs/saved-choirs.component";
import { ViewBookingsComponent } from "./home/view-bookings/view-bookings.component";
import { NewsletterComponent } from "./home/newsletter/newsletter.component";
import { AngularFireMessagingModule } from "@angular/fire/compat/messaging";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireModule } from "@angular/fire/compat";
import { MessagingService } from "../serivce/messaging.service";
import { AsyncPipe } from "@angular/common";

import { environment } from "../../environments/environment";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { UniformSectionComponent } from "./home/uniform-section/uniform-section.component";
import { ChangePasswordComponent } from './home/change-password/change-password.component';
import { PendingTansactionsComponent } from './home/pending-tansactions/pending-tansactions.component';
import { PaymentCardsComponent } from "./home/payment-cards/payment-cards.component";

@NgModule({
  declarations: [
    MainComponent,
    FullComponent,
    AppSidebarComponent,
    MainHeaderComponent,
    HomeComponent,
    QuestionListComponent,
    ProfileComponent,
    ChoirDetailComponent,
    SavedChoirsComponent,
    ViewBookingsComponent,
    NewsletterComponent,
    UniformSectionComponent,
    ChangePasswordComponent,
    PendingTansactionsComponent,
    PaymentCardsComponent
  ],
  imports: [
    CommonModule,
    MainRoutingModule,
    SharedModule,
    GoogleChartsModule,
    

    NgMultiSelectDropDownModule.forRoot(),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(environment.firebase),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    // IntercomModule.forRoot({
    //   appId: "bn64enia",  // from your Intercom config
    //   updateOnRouterChange: true // will automatically run `update` on router event changes. Default: `false`
    // })

    // DemoMaterialModule
  ],
  providers: [MainService, , MessagingService, AsyncPipe],
})
export class MainModule {}
